var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      directives: [{ name: "sticky", rawName: "v-sticky" }],
      staticClass: "sub-navigation"
    },
    [
      _c(
        "ul",
        [
          _vm._l(_vm.items, function(item) {
            return _c(
              "li",
              { key: item.key, class: { active: _vm.page === item.key } },
              [
                item.key === "messages"
                  ? _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openMessages.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("Icon", {
                          attrs: {
                            icon: _vm.loadingMessages ? "loading" : item.icon,
                            spin: _vm.loadingMessages
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(item.text))
                        ]),
                        _vm._v(" "),
                        _vm.newMessagesCount
                          ? _c(
                              "span",
                              {
                                staticClass: "count-bubble count-bubble--left"
                              },
                              [_vm._v(_vm._s(_vm.newMessagesCount))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _c(
                      "a",
                      { attrs: { href: item.url } },
                      [
                        _c("Icon", { attrs: { icon: item.icon } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(item.text))
                        ])
                      ],
                      1
                    )
              ]
            )
          }),
          _vm._v(" "),
          _vm.shouldShow("logout")
            ? _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("Icon", { attrs: { icon: "logout" } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [_vm._v("Abmelden")])
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }